$(document).ready(function () {
	$('.hw-header .js-sub-menu-item.dropdown > a').on('click', function () {
		$(this).next('.submenu').addClass('open');
		$('body').addClass('scroll-hide');
	});
	$('.js-close-submenu').on('click', function () {
		$(this).parents().removeClass('open');
		$('body').removeClass('scroll-hide');
	});

	// Header sub menu filter js Start here
	$('.submenu__nav-content li').on( 'mouseenter', 'a', function() {
		var filter = $(this).attr('data-filter');

		$('.js-submenu-slider .swiper-slide').css('display', 'none')
		$('.js-submenu-slider .swiper-slide' + filter).css('display', '')
		$( '.js-swiper-filter li a' ).removeClass( 'active' );
		$( this ).addClass( 'active' );

		productMenuSwiper.updateSize();
		productMenuSwiper.updateSlides();
		productMenuSwiper.updateProgress();
		productMenuSwiper.updateSlidesClasses();
		productMenuSwiper.slideTo(0);
		productMenuSwiper.scrollbar.updateSize();
		return false;
	  });
	// Header sub menu filter js End here

	// Header sub menu slider Start here
	var productMenuSwiper = new Swiper(".js-submenu-slider", {
		slidesPerView: 2.6,
		grabCursor: false,
		freeMode: true,
		scrollbar: {
			el: ".swiper-scrollbar",
		},
		breakpoints: {
			250: {
				slidesPerView: 1.2,
			},
			475: {
				slidesPerView: 2.2,
			},
			768: {
				slidesPerView: 2.6,
			},
		},
	});
	// Header sub menu slider End here

	// Home page collection section slider Start here
	var collectionsSwiper = new Swiper(".js-collections-slider", {
		slidesPerView: 3,
		// grabCursor: true,
		freeMode: true,
		// loop: true,
		// scrollbar: {
		// 	el: ".swiper-scrollbar",
		// },
		// mousewheel: {
		// 	releaseOnEdges: true,
		// },
		breakpoints: {
			250: {
				slidesPerView: 1.06,
			},
			575: {
				slidesPerView: 2.2,
			},
			768: {
				slidesPerView: 2.4,
			},
			991: {
				slidesPerView: 2.8,
			},
			1500: {
				slidesPerView: 3,
			},
		},
	});
	// Home page collection section slider End here

	// Home page Best Sellers Slider Start here
	/* var init = false;
	var bestSellersSwiper; */
	function swiperCard() {
		/* if (window.innerWidth >= 768) {
			if (!init) {
			init = true; */
			bestSellersSwiper = new Swiper(".js-best-sellers-slider", {
				slidesPerView: 3,
				grabCursor: true,
				centeredSlides: false,
				freeMode: true,
				scrollbar: {
					el: ".swiper-scrollbar",
					draggable: true,
				},
				breakpoints: {
					250: {
						slidesPerView: 1.06,
					},
					575: {
						slidesPerView: 2.2,
					},
					768: {
						slidesPerView: 2.4,
					},
					991: {
						slidesPerView: 2.8,
					},
					1500: {
						slidesPerView: 3,
					},
				},
			});
			/* }
		} else if (init) {
			bestSellersSwiper.destroy();
			init = false;
		} */
	}
	swiperCard();
	window.addEventListener("resize", swiperCard);
	// Home page Best Sellers Slider End here

	/* Footer link Accordion js Start */
	$(window).on("load", function(){
		if($(window).width() <= 767){
			$('.js-accordion-title').click(function (e) {
				var dropDown = $(this).closest('.js-accordion-card').find('.js-accordion-panel');
				$(this).closest('.js-accordion').find('.js-accordion-panel').not(dropDown).slideUp();

				if ($(this).hasClass('is-active')) {
					$(this).removeClass('is-active');
				} else {
					$(this).closest('.js-accordion').find('.js-accordion-title.is-active').removeClass('is-active');
					$(this).addClass('is-active');
				}

				dropDown.stop(false, true).slideToggle();
				e.preventDefault();
			});
		}
	})
	/* Footer link Accordion js End */

	// Header Class remove add
	let announcementBar = $('.announcement-bar');
	let announcementBarHeight = announcementBar.height();

	function stickyHeader() {
		if ($(window).scrollTop() > announcementBarHeight) {
			$('.hw-header').addClass('sticky').css('top', '0');
		} else {
			$('.hw-header').removeClass('sticky').css('top', `${announcementBarHeight}px`);
		}
	}

	stickyHeader();
	window.addEventListener("resize", stickyHeader);
	document.addEventListener("scroll", (event) => {
		stickyHeader();
	});
    // Header Class remove add

	// Mobile menu js Start here
	$(document).on('click', '.js-mobile-menu', function(){
		$(this).parents('.hw-header__wrap').find('.hw-header__menu-wrap').addClass('open-menu');
		$(this).parents('.js-mobile-menu').addClass('active');
		$('body').addClass('scroll-hide');
	});

	$(document).on('click', '.js-mobile-menu-close', function(){
		$(this).parents('.hw-header__wrap').find('.hw-header__menu-wrap').removeClass('open-menu');
		$(this).parents('.js-mobile-menu').removeClass('active');
		$('body').removeClass('scroll-hide');
	});
	// Mobile menu js End here

	// // Side Cast js Start Here
	// $(document).on('click', '.js-side-cart-open', function(){
    //     $('.hw-side-cart').addClass('open');
    //     $('body').addClass('scroll-hide')
	// 	$('.body-overlay').addClass('visible-overlay');
    // })
    // $(document).on('click', '.js-side-cart-close', function(){
    //     $('.hw-side-cart').removeClass('open');
    //     $('body').removeClass('scroll-hide')
	// 	$('.body-overlay').removeClass('visible-overlay');
    // })
	// // Side Cast js End Here

	// On click body Side Cast close js Start Here
	$(document).on('click', '.body-overlay.visible-overlay', function(){
        $('.hw-side-cart').removeClass('open');
        $('body').removeClass('scroll-hide')
		$(this).removeClass('visible-overlay');
    })
	// On click body Side Cast close js End Here

	// product section accordian js Start here
	$('.js-accordion-ui-title').click(function (e) {
		var dropDown = $(this).closest('.js-accordion-ui-card').find('.js-accordion-ui-panel');
		$(this).closest('.js-accordion-ui').find('.js-accordion-ui-panel').not(dropDown).slideUp();

		if ($(this).hasClass('is-active')) {
			$(this).removeClass('is-active');
		} else {
			$(this).closest('.js-accordion-ui').find('.js-accordion-ui-title.is-active').removeClass('is-active');
			$(this).addClass('is-active');
		}

		dropDown.stop(false, true).slideToggle();
		e.preventDefault();
	});
	// product section accordian js End here

	// Product slider js Start Here
	var ProductMainSwiper = new Swiper(".js-product-nav-slider", {
		slidesPerView: 4,
		freeMode: true,
		watchSlidesProgress: true,
		breakpoints: {
			250: {
				slidesPerView: 3.8,
			},
			768: {
				slidesPerView: 4,
			},
		},
	  });
	  var ProductNavSwiper = new Swiper(".js-product-main-slider", {
		slidesPerView: 1,
		navigation: {
		  nextEl: ".swiper-button-next",
		  prevEl: ".swiper-button-prev",
		},
		thumbs: {
		  swiper: ProductMainSwiper,
		},
	});
	// Product slider js End Here

	// Shipping Details Slider JS Start Here
	var jsShippingDetailsSlide = new Swiper(".js-shipping-details-slider", {
		slidesPerView: 1,
		centeredSlides: true,
		loop: true,
		autoplay: {
		  delay: 2500,
		  disableOnInteraction: false,
		},
		pagination: {
		  el: ".swiper-pagination",
		  clickable: true,
		},
	});
	// Shipping Details Slider JS End Here

	// Product
	$(".js-qty-input i").click(function () {
		val = parseInt($(this).parent().find("input").val());

		if ($(this).hasClass("js-less")) {
		  val = val - 1;
		} else if ($(this).hasClass("js-more")) {
		  val = val + 1;
		}

		if (val < 1) {
		  val = 1;
		}

		$(this).parent().find("input").val(val);
	  });

	/* set header height based on announcement Bar Height js start here */
	// function headerPosition() {
	// 	let announcementBar = $('.utility-bar');
	// 	let announcementBarHeight = announcementBar.height();
	// 	let headerBlock = $('.hw-header');

	// 	if(!headerBlock.hasClass('sticky')){
	// 		headerBlock.css('top',announcementBarHeight);
	// 	} else{
	// 		headerBlock.css('top','0');
	// 	}
	// }
	// headerPosition();
	// window.addEventListener("resize", headerPosition);
	// document.addEventListener("scroll", (event) => {
	// 	headerPosition();
	// });

	/* set header height based on announcement Bar Height js end here */

	function bannerPosition() {
		let announcementBar = $('.utility-bar');
		let announcementBarHeight = announcementBar.height();
		let headerBlock = $('.hw-header');
		let bannerImageBlock;
		let bannerVideoBlock;

		if($('.hw-banner__bg-image').length > 0){
			bannerImageBlock =  $('.hw-banner__bg-image');

			if($(window).width() >= 768 && !headerBlock.hasClass('sticky')){
				bannerImageBlock.css('padding-bottom',`calc(100vh - ${announcementBarHeight}px)`);
			} else if($(window).width() >= 768 && headerBlock.hasClass('sticky')){
				bannerImageBlock.css('padding-bottom',`calc(100vh - ${announcementBarHeight}px)`);
			} else if($(window).width() < 768){
				bannerImageBlock.css('padding-bottom',`550px`);
			}
		}
		if($('.hw-banner__bg-video').length > 0){
			bannerVideoBlock =  $('.hw-banner__bg-video');

			if($(window).width() >= 768 && !headerBlock.hasClass('sticky')){
				bannerVideoBlock.css('padding-bottom',`calc(100vh - ${announcementBarHeight}px)`);
			} else if($(window).width() >= 768 && headerBlock.hasClass('sticky')){
				bannerVideoBlock.css('padding-bottom',`calc(100vh - ${announcementBarHeight}px)`);
			} else if($(window).width() < 768){
				bannerVideoBlock.css('padding-bottom',`550px`);
			}
		}
	}
	bannerPosition();
	window.addEventListener("resize", bannerPosition);
	document.addEventListener("scroll", (event) => {
		bannerPosition();
	});

	// This Function Using For support page mobile navigation
	$('.js_mb_nav').on('change', function(){
		var selectedValue = $(this).val();
		$('.hw-custom-button-link').removeClass('active');
		$('.hw-custom-button-link').filter('[href="' + selectedValue + '"]').addClass('active');
		$('.js_content .items').hide();
		$(selectedValue).fadeIn();
	})


	// Check for a hash in the URL
	if (window.location.hash) {
		// Get the hash value and remove the '#' symbol
		var target = window.location.hash.substring(1);

		// Scroll to the element with the corresponding ID
		scrollToElement(target);
	}

	// Function to scroll to a specific element by ID
	function scrollToElement(target) {
		var $targetElement = $("#" + target);
		if ($(window).width() > 991) {
			if ($targetElement.length) {
			
				// Scroll to the element with animation
				$('.js_mb_nav').val('#'+target).change();


				$('.hw-custom-button-link').removeClass('active');
				$('.hw-custom-button-link').filter(function () {
					return $(this).attr('href') === '#' + target;
				}).addClass('active');
				$('.js_content .items').hide();
				$targetElement.fadeIn();
				// var stringValue = selectedValue.replace('#', '');
				setTimeout(function(){
					var toSection = $($targetElement).offset().top - 70;
					$("html, body").animate({scrollTop:toSection}, 0)
				},300);
			}
		}
		else {
			var title = target;

			$(".js-manuals-sub-title").text(title);
			console.log(title, 'title');

			$('.hw-custom-button-link').removeClass('active');
			$('.hw-custom-button-link').filter(function () {
				return $(this).attr('href') === '#' + target;
			}).addClass('active');

			$('.js_content .items').hide();
			$targetElement.fadeIn();

			$(".eq-faqs .eq-manuals-sub").addClass("show-mobile");
			$(".eq-faqs .eq-manuals-wrapper").addClass("open");

			$targetElement.fadeIn();
			
			setTimeout(function(){
				var toSection = $($targetElement).offset().top - 100;
				$("html, body").animate({scrollTop:toSection}, 0)
			},300);
		}
	}

	// Footer link scroll to section
	$('.js-accordion-panel li a').click(function(){
		if ($(window).width() > 991) {	
			let getAttr = $(this).attr('href');
			var $targetElement = $(getAttr);

			// Hide all content items and show the selected one
			$('.js_content .items').hide();

			// Update active class for navigation links
			$('.hw-custom-button-link').removeClass('active');
			$('.hw-custom-button-link').filter('[href="' + getAttr + '"]').addClass('active');

			// Update mobile navigation value and trigger change event
			$('.js_mb_nav').val(getAttr).change();

			// Fade in the selected content item
			$targetElement.fadeIn();

			setTimeout(function(){
				var toSection = $(getAttr).offset().top - 70;
				$("html, body").animate({scrollTop:toSection}, 0)
			},100);
		}
		else {
			let getAttr = $(this).attr('href');
			var $targetElement = $(getAttr);

			$(".hw-custom-button-link").removeClass("active");
			$('.hw-custom-button-link').filter('[href="' + getAttr + '"]').addClass('active');
			var activeTitle = $('.hw-custom-button-link').filter('[href="' + getAttr + '"]');

			var title = $(activeTitle).text().trim();

			$(".js-manuals-sub-title").text(title);
			console.log(title, 'title');

			$('.js_content .items').hide();
			$targetElement.fadeIn();

			$(".eq-faqs .eq-manuals-sub").addClass("show-mobile");
			$(".eq-faqs .eq-manuals-wrapper").addClass("open");

			setTimeout(function(){
				var toSection = $(getAttr).offset().top - 100;
				$("html, body").animate({scrollTop:toSection}, 0)
			},100);
		}
	});

	// Sidebar link show to section
	$('.js_nav li a').click(function(e){
		e.preventDefault();
		var getAttr = $(this).attr('href');
		var $targetElement = $(getAttr);

		if ($(window).width() > 991) {	

			var title = $(this).text().trim();

			$(".js-manuals-sub-title").text(title);
			// Hide all content items and show the selected one
			$('.js_content .items').hide();

			// Update active class for navigation links
			$('.hw-custom-button-link').removeClass('active');
			$('.hw-custom-button-link').filter('[href="' + getAttr + '"]').addClass('active');

			// Fade in the selected content item
			$targetElement.fadeIn();

		}
		else {
			var title = $(this).text().trim();

			$(".js-manuals-sub-title").text(title);
			console.log(title, 'title');
			
			$(".hw-custom-button-link").removeClass("active");
			$('.hw-custom-button-link').filter('[href="' + getAttr + '"]').addClass('active');

			$('.js_content .items').hide();
			$targetElement.fadeIn();

			$(".eq-faqs .eq-manuals-sub").addClass("show-mobile");
			$(".eq-faqs .eq-manuals-wrapper").addClass("open");
		}
	});


	$('.faq-header').click(function() {

		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).next().slideUp();
		} else{
			$('.faq-content').slideUp();
			$('.faq-header').removeClass('active');
			$(this).addClass('active').next().slideDown();
		}
	});


});

$(document).ready(function () {
	// $(window).on('load', function () {
	// 	$('.jsViewLess').trigger('click');
	// });
	// $(document).on('click', '.jsViewLess', function () {
	// 	var self = this;
	// 	var oElement = document.getElementById("product-desc");
	// 	Cutter.run(oElement, oElement, 30);
	// 	$(this).hide();

	// 	var intervalId = setInterval(function () {
	// 		if ($(".product__description > div").length > 0) {
	// 			var lastElement = $(".product__description > div").children(":not(:last)").last();
	// 			var spanElement = document.createElement("span");
	// 			spanElement.innerHTML = "...";
	// 			lastElement.append(spanElement);
	// 			clearInterval(intervalId);
	// 		}
	// 	}, 0);

	// 	$(".jsViewMore").click(function () {
	// 		$(self).show();
	// 	})
	// 	return false;
	// });
	$('.product__description').Cuttr({
		//options here
		truncate: 'words',
		length: 40,
		readMore: true,
		readMoreText: 'Read more',
		readLessText: 'Read less',
		ending: '...',
		readMoreBtnPosition: 'inside',
		readMoreBtnTag: 'a',
	  });


	let headerMenu = $('.hw-header__menu-wrap');
	let hamburgerIcon = $('.js-mobile-menu');

	function menuPosition() {
		let announcementBar = $('.utility-bar');
		let announcementBarHeight = announcementBar.height();

		if($(headerMenu).length > 0){
			if($(window).width() <= 992 && headerMenu.hasClass('open-menu')){
				headerMenu.css({
					height: `calc(100% - ${announcementBarHeight}px)`,
					top: announcementBarHeight
				});
			}
		}
	}

	function checkMenu() {
		if(headerMenu.hasClass('open-menu')){
			menuPosition();
		}
	}

	$(hamburgerIcon).on('click' ,function () {
		setTimeout(() => {
			checkMenu(); 
		}, 500);
	});

	window.addEventListener("resize", checkMenu);
	
	const API_URL = "https://hoffmanwatches.com/browsing_context_suggestions.json";
	let countryCode = "";
	let countriesList = ["AT","BE","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE"];
	const fetchCountry = async() => {
		try {
			if(window.localStorage.getItem('hw_country') == null ||  window.localStorage.getItem('hw_country') == "") { 
				const response = await fetch(API_URL);
				if(!response.ok) throw Error("Could not fetch country");
				const countryData = await response.json();
				countryCode = countryData.detected_values.country.handle;
				window.localStorage.setItem("hw_country" , countryCode);
				$('.localization-form input[name="country_code"]').val(countryCode);
                $('.localization-form').submit();
			}
			else {
				countryCode = window.localStorage.getItem('hw_country');
			}
			if(countryCode == "US") {
				$('.js-not-us').hide();
				$('.js-in-us').show();
			}
			else {
				$('.js-not-us').show();
				$('.js-in-us').hide();
			}
		}
		catch (e) {
			console.error(e.message);
		}
	}

	fetchCountry();
});

function isElementInViewport(el) {
  var $el = $(el);
  if (!$el.length) return false; // safety check

  var elementTop = $el.offset().top;
  var elementBottom = elementTop + $el.outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
}

function toggleStickyAddToCart() {
  // ❌ Do nothing if sticky ATC does not exist
  if (!$(".sticky-add-to-cart").length) return;

  if (isElementInViewport(".product-form")) {
    $(".sticky-add-to-cart").removeClass("active");
  } else {
    $(".sticky-add-to-cart").addClass("active");
  }
}

$(document).ready(function () {
  // Run only if sticky exists
  if ($(".sticky-add-to-cart").length) {
    toggleStickyAddToCart();
    $(window).on("scroll resize", toggleStickyAddToCart);
  }

//   FAQ JS start here
//   $(".eq-faq-main li").on("click", function () {
//     var tab = $(this).data("tab");
//     $(".eq-faq-main li").removeClass("active");
//     $(this).addClass("active");
//     $(".eq-faq-sub ul").hide().removeClass('active');
//     $('.eq-faq-sub ul[data-parent="' + tab + '"]').show().addClass('active');
//     $(".eq-faq-answer").hide();
// 	if ($('.eq-faq-sub ul[data-parent="' + tab + '"]').hasClass("active")) {
// 		$('.eq-faq-sub ul[data-parent="' + tab + '"]').parents(".eq-faq-sub").addClass("show-mobile");
// 	}
//   });

//   // Column 2 click
//   $(".eq-faq-sub li").on("click", function () {
//     var content = $(this).data("content");
//     $(".eq-faq-sub li").removeClass("active");
//     $(this).addClass("active");
//     $(".eq-faq-answer").hide().removeClass("active");
//     $("#" + content).fadeIn().addClass("active");
// 	if ($('.eq-faq-content .eq-faq-answer').hasClass("active")) {
// 		$('.eq-faq-content').addClass("show-mobile");
// 	}
//   });

//   $(".js-faq-sub-back-btn").on("click", function(){
// 	$(this).parents(".eq-faq-sub").removeClass("show-mobile");
//   })
  //   FAQ JS end here
});


$(document).ready(function () {
  function validateFaqContent() {
    $(".eq-faq-main li").each(function () {
      var tab = $(this).data("tab");
      var relatedList = $('.eq-faq-sub ul[data-parent="' + tab + '"]');
      if (!relatedList.length || relatedList.find(".faq-item").length === 0) {
        $(this).addClass("disabled no-arrow");
      }
    });

    // QUESTION VALIDATION
    $(".js-faq-question").each(function () {
      var contentId = $(this).data("content");
      var answer = $("#" + contentId);

      if (!answer.length || $.trim(answer.text()) === "") {
        $(this).addClass("no-arrow");
      }
    });
  }

  function bindFaqEvents() {

    $(".eq-faq-main li").off("click");
    $(".js-faq-question").off("click");

	$(".eq-faq-main-top li").off("click");
	$(".back-button-faq").off("click");
	$(".eq-faq-main-top li:not(.disabled)").on("click", function (e) {
		e.preventDefault();
		var contentId = $(this).data("tab");
		if ($(window).width() > 991) 
		{
			$(".eq-faq-main-top li").removeClass("active");
			$(this).addClass("active");
			$(".eq-faq-top-answer").hide();
			$("#" + contentId).fadeIn();
		}
		else
		{
			if($(this).hasClass("active"))
			{
				$(this).removeClass("active");
				$(this).find(".eq-faq-answer").slideUp();
			}
			else
			{
				$(".eq-faq-main-top li").removeClass("active");
				$(this).addClass("active");
				$(".eq-faq-main-top .eq-faq-answer").slideUp();
				$(this).find(".eq-faq-answer").slideDown();
			}
			
		}
	});

    if ($(window).width() > 991) {

      
    // DESKTOP
		$(".eq-faq-main li:not(.disabled)").on("click", function () {
        var tab = $(this).data("tab");

        $(".eq-faq-main li").removeClass("active");
        $(this).addClass("active");

        $(".eq-faq-sub ul").hide();
        $('.eq-faq-sub ul[data-parent="' + tab + '"]').show();
		
        $(".eq-faq-answer").hide();
      });

      $(".js-faq-question").on("click", function () {
        var contentId = $(this).parents().data("content");
		console.log(contentId, 'contentId');
		
        $(".js-faq-question").parents("li").removeClass("active");
        $(this).parents("li").addClass("active");

        $(".eq-faq-answer").hide();
        $("#" + contentId).fadeIn();
      });
 
    } else {

    // MOBILE

      $(".eq-faq-main li:not(.disabled)").on("click", function () {
        var tab = $(this).data("tab");

		var categoryTitle = $(this).text().trim();
		$(".js-faq-sub-title").text(categoryTitle);

        $(".eq-faq-main li").removeClass("active");
        $(this).addClass("active");

        $(".eq-faq-sub").addClass("show-mobile");
        $(".eq-faq-sub ul").hide();
        $('.eq-faq-sub ul[data-parent="' + tab + '"]').show();
      });

      $(".js-faq-question").on("click", function () {
        var item = $(this).closest(".faq-item");
        var inlineAnswer = item.find(".eq-faq-answer--inline");

        // close others
        $(".eq-faq-answer--inline").not(inlineAnswer).slideUp();
        $(".faq-item").not(item).removeClass("active");

        // toggle current
        item.toggleClass("active");
        inlineAnswer.slideToggle();
      });
    }
  }

	// INIT
  validateFaqContent();
  bindFaqEvents();

  $(window).on("resize", function () {
    bindFaqEvents();
  });

  $(".js-faq-sub-back-btn").on("click", function () {
    $(".eq-faq-sub").removeClass("show-mobile");
  });

});

$(document).ready(function () {

  function bindManualsEvents() {

    $(".js-manuals-question").off("click");
    $(".js-manuals-sub-back-btn").off("click");

    /* ==========================
       DESKTOP
    ========================== */
    if ($(window).width() > 991) {

      $(".js-manuals-question").on("click", function () {

        var contentId = $(this).closest(".manuals-item").data("content");

        // Active state
        $(".manuals-item").removeClass("active");
        $(this).closest(".manuals-item").addClass("active");

        // Show answer
        $(".eq-manuals-answer").hide();
        $("#" + contentId).fadeIn(200);
      });

    } else {

    /* ==========================
       MOBILE
    ========================== */
 
      $(".js-manuals-question").on("click", function () {
		console.log("test");
		
        var contentId = $(this).closest(".manuals-item").data("content");
        var title = $(this).text().trim();

        $(".js-manuals-sub-title").text(title);
		console.log(title, 'title');
		
        $(".manuals-item").removeClass("active");
        $(this).closest(".manuals-item").addClass("active");

        $(".eq-manuals-answer").hide();
        $("#" + contentId).show();

        $(".eq-manuals-sub").addClass("show-mobile");
		$(".eq-manuals-wrapper").addClass("open");
      });

      $(".js-manuals-sub-back-btn").on("click", function () {
        $(".eq-manuals-sub").removeClass("show-mobile");
		$(".eq-manuals-wrapper").removeClass("open");
      });
    }
  }

  /* INIT */
  bindManualsEvents();

  $(window).on("resize", function () {
    bindManualsEvents();
  });

});





